import fetchAPI from 'utils/fetchAPI';

export const PLAN = {
  PAY_AS_YOU_GO: 'pay-as-you-go',
  YEARLY: 'yearly-data',
  MONTHLY: 'monthly-data',
};
export const SELECT_PLAN = 'SELECT_PLAN';
export const RECEIVED_PUBLIC_BRAINTREE_TOKEN =
  'RECEIVED_PUBLIC_BRAINTREE_TOKEN';
export const RECEIVED_PLAN_ID = 'RECEIVED_PLAN_ID';
export const RECEIVED_PAYMENT_ID = 'RECEIVED_PAYMENT_ID';
export const RECEIVED_CUSTOMER_ID = 'RECEIVED_CUSTOMER_ID';
export const RECEIVED_NUMBER_OF_SUBSCRIBERS = 'RECEIVED_NUMBER_OF_SUBSCRIBERS';
export const CLEAN_UP_AFTER_SUCCESSFUL_SUBSCRIPTION =
  'CLEAN_UP_AFTER_SUCCESSFUL_SUBSCRIPTION';

function selectPlan(planId) {
  return {
    type: SELECT_PLAN,
    planId,
  };
}

function receivedPublicBraintreeToken(token) {
  return {
    type: RECEIVED_PUBLIC_BRAINTREE_TOKEN,
    token,
  };
}

function receivePlanId(planId) {
  return {
    type: RECEIVED_PLAN_ID,
    id: planId,
  };
}

function receivePaymentId(id) {
  return {
    type: RECEIVED_PAYMENT_ID,
    id,
  };
}

function cleanUp() {
  return {
    type: CLEAN_UP_AFTER_SUCCESSFUL_SUBSCRIPTION,
  };
}

function receiveCustomerId(id) {
  return {
    type: RECEIVED_CUSTOMER_ID,
    id,
  };
}

function receiveNumberOfSubscribers(quantity) {
  return {
    type: RECEIVED_NUMBER_OF_SUBSCRIBERS,
    quantity,
  };
}

export const makePlanSelection = planId => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch(selectPlan(planId));
    resolve();
  });

export const getPublicBrainTreeToken = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    fetchAPI({
      endpoint: '/payments/token',
      method: 'GET',
    })
      .then(response => response.json())
      .then(json => {
        dispatch(receivedPublicBraintreeToken(json.token));
        resolve(json.token);
      })
      .catch(ex => reject(ex));
  });

export const makePlanPayment = ({ nonce, user, billInfo, amount = 1 }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const endpoint = '/account/gold/braintree';
    const body = JSON.stringify({
      nonce,
      user,
      billing_info: billInfo,
      amount,
    });
    fetchAPI({
      endpoint,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    }).then(res => {
      if (res.ok) {
        return res.json().then(json => resolve(json));
      } else if (res.status === 500) {
        return res.json().then(json => reject(json));
      }
      return res.text().then(text => reject({ error_message: text }));
    });
  });

export const assignPaidUser = ({ users }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const planId = getState().dataSubscription.planId;
    const paymentId = getState().dataSubscription.paymentId;
    const customerId = getState().dataSubscription.customerId;
    const endpoint =
      planId === PLAN.PAY_AS_YOU_GO
        ? '/credit/transaction/assign'
        : '/credit/subscription/assign';
    const body =
      planId === PLAN.PAY_AS_YOU_GO
        ? JSON.stringify({
            users,
            transaction_id: paymentId,
            customer_id: customerId,
          })
        : JSON.stringify({
            users,
            subscription_id: paymentId,
            customer_id: customerId,
          });
    fetchAPI({
      endpoint,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    }).then(res => {
      if (res.ok) {
        dispatch(cleanUp());
        return resolve();
      }
      if (res.status === 404) reject('SUBSCRIPTION_USER_NOT_FOUND');
      return res.json().then(json => {
        if (
          json.error_code &&
          json.error_code === 'SUBSCRIPTION_ALREADY_ASSIGNED'
        ) {
          return reject(json.error_code);
        }
        return reject();
      });
    });
  });

export const verifyDiscountCode = ({ code, plan }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    fetchAPI({
      endpoint: `/payments/discount?code=${code}&plan_id=${plan}`,
      method: 'GET',
    })
      .then(res => res.json())
      .then(json => {
        if (json.amount) return resolve(json.amount); // return discounted amount
        if (json.error_code) return reject(json.error_code);
        return reject();
      });
  });

export const payCreditOffline = ({ amount = 1, billInfo }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const endpoint = '/account/offline_payment';
    const body = JSON.stringify({
      amount,
      billing_info: billInfo,
    });
    fetchAPI({
      endpoint,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    }).then(res => {
      if (res.ok) {
        return resolve();
      } else if (res.status === 500) {
        return res.json().then(json => reject(json));
      }
      return res.text().then(text => reject({ error_message: text }));
    });
  });

export const paymentErrorNotify = ({
  amount = 1,
  billInfo,
  status,
  payment_method,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const endpoint = '/account/notify';
    const body = JSON.stringify({
      amount,
      billing_info: billInfo,
      status,
      payment_method,
    });
    fetchAPI({
      endpoint,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    })
      .then(res => {
        if (res.ok) {
          return resolve(res);
        } else if (res.status === 500) return reject(res.json().error_message);
        return res.text();
      })
      .then(text => reject(text));
  });



// WEBPACK FOOTER //
// ./app/actions/DataSubscriptionActionCreators.js